import { DialogCloseResult, DialogService } from 'aurelia-dialog';
import { autoinject } from 'aurelia-framework';

interface ActivateLike<TArg = unknown> {
  activate(_: TArg): void | Promise<void>;
}

interface DialogCloser<TResult = unknown> {
  closeWithResult(output?: TResult): TResult;
  cancelDialog(): void;
}

type DialogResult<T> = DialogCloseResult & {
  output?: T;
};

@autoinject()
class DialogHandler {
  constructor(private dialog: DialogService) {}

  open<T extends ActivateLike & DialogCloser>(
    ViewModel: new (...args: unknown[]) => T,
    data?: T extends { activate: (d: infer D) => unknown } ? D : never,
    options?: Parameters<DialogService['open']>
  ) {
    type DResult = DialogResult<ReturnType<T['closeWithResult']>>;
    return new Promise<DResult>((resolve) => {
      // eslint-disable-next-line @typescript-eslint/no-floating-promises
      this.dialog
        .open({
          viewModel: ViewModel,
          model: data,
          position: () => {
            //
          },
          ...options,
        })
        .whenClosed((result) => {
          resolve(result as DResult);
        });
    });
  }
}

export { DialogHandler };

export type { ActivateLike, DialogCloser, DialogResult };
